<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom grocery-bag-oveview-page"
    role="main"
  >
    <div class="row">
      <preamble-block
        class="col-12_md-12_lg-5"
        :prefix="prefix"
        :title="title"
        :preamble="preamble"
        align="left"
      />

      <div
        class="col-12_md-12_lg-6"
        data-push-left="off_lg-1"
      >
        <StorePicker />
      </div>
    </div>

    <UserGroceryBagInfo
      :bags="bags"
    />

    <div
      v-if="bags"
      class="row-noGutters"
    >
      <div class="col-12 filter-header">
        <button
          v-if="hasFilter"
          type="button"
          class="link font-text-2"
          @click="clearFilter"
        >
          Rensa filter
        </button>
      </div>

      <div class="col-12 order-options">
        <div class="order-options-items">
          <div class="order-options-items--peoples">
            <p
              v-if="peoples"
              class="order-label"
            >
              Portioner
            </p>
            <p
              v-if="peoples"
              class="radio-wrapper"
            >
              <template
                v-for="person in peoples"
              >
                <input
                  :id="person"
                  :key="'input-' + person"
                  v-model="selectedPersons"
                  :value="person"
                  name="name"
                  type="radio"
                  :disabled="!canSelectPerson(person)"
                >
                <label
                  :key="'label-' + person"
                  :for="person"
                >{{ person }}</label>
              </template>
            </p>
          </div>
          <div class="order-options-items--days">
            <p
              v-if="days"
              class="order-label"
            >
              Dagar
            </p>
            <p
              v-if="days"
              class="radio-wrapper"
            >
              <template
                v-for="day in days"
              >
                <input
                  :id="'-day-target-' + day"
                  :key="'day-' + day"
                  v-model="selectedDays"
                  :value="day"
                  name="day-target-"
                  type="radio"
                  :disabled="!canSelectDay(day)"
                >
                <label
                  :key="'day-label-' + day"
                  :for="'-day-target-' + day"
                >{{ day }}</label>
              </template>
            </p>
          </div>
          <div class="order-options-items--gluten filter-item">
            <div class="checkbox">
              <input
                id="glutenFreeFilter"
                v-model="glutenFree"
                type="checkbox"
                class="checkbox__input"
                :disabled="!canSelectGlutenFree"
              >
              <label
                for="glutenFreeFilter"
                class="checkbox__label"
              >Glutenfri</label>
            </div>
          </div>
          <div class="order-options-items--lactose filter-item">
            <div class="checkbox">
              <input
                id="lactoseFreeFilter"
                v-model="lactoseFree"
                type="checkbox"
                class="checkbox__input"
                :disabled="!canSelectLactoseFree"
              >
              <label
                for="lactoseFreeFilter"
                class="checkbox__label"
              >Laktosfri</label>
            </div>
          </div>
          <div class="order-options-items--vegetarian filter-item">
            <div class="checkbox">
              <input
                id="vegetarianFilter"
                v-model="vegetarian"
                type="checkbox"
                class="checkbox__input"
                :disabled="!canSelectVegetarian"
              >
              <label
                for="vegetarianFilter"
                class="checkbox__label"
              >Vego</label>
            </div>
          </div>
          <div class="order-options-items--discount filter-item">
            <div
              v-if="discountCode && !showDiscountCodeInput"
              class="discount-code-input"
            >
              <span class="code">{{ discountCode }}</span>
              <a
                href="#"
                @click.prevent="showDiscountCodeInput = true;"
              >
                Ändra rabattkod
              </a>
            </div>

            <a
              v-if="!discountCode && !showDiscountCodeInput"
              href="#"
              @click.prevent="showDiscountCodeInput = true;"
            >
              Har du en rabattkod?
            </a>

            <div
              v-if="showDiscountCodeInput"
              class="discount-code-container"
            >
              <input
                v-model="discountCode"
                type="text"
                class="discount-code-input"
              >
              <button
                class="button button--20 button-primary"
                @click="applyDiscountCode"
              >
                <template v-if="discountCode && discountCode.length > 0">
                  Använd
                </template>

                <template v-else>
                  Rensa
                </template>
              </button>
            </div>
          </div>
        </div>
      </div>

      <section class="col-12 content-area-wrapper">
        <block-grid
          v-if="bagBlocks.length || isEditable"
          v-edit="'ContentArea'"
          :blocks="bagBlocks"
          :force-row-size="'third'"
        />

        <div class="legal">
          <small>* Vårt nykundserbjudande är ett "från-pris", och gäller i ett urval av butiker.</small>
        </div>
      </section>
    </div>
    <div
      v-if="accordionBlocks.length || isEditable"
      class="accordion-block-wrapper"
    >
      <sub-heading
        v-if="accordionsHeading || isEditable"
        :v-edit-heading="'AccordionsHeading'"
        :heading="accordionsHeading"
      />

      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          v-edit="'AccordionBlocks'"
        >
          <accordion-group
            :items="accordionBlocks | stringify('content')"
            :limit="isEditable ? 0 : accordionShowMoreLimit"
            :tracking-scope="accordionsHeading"
          />
        </div>
      </in-view>
    </div>
    <navigation-blocks
      v-if="allNavigatablePages.length"
      :navigation-blocks="allNavigatablePages"
      :display-image-state="displayImagesInNavigationBlocks"
    >
      <sub-heading
        v-if="navigationHeading || isEditable"
        :v-edit-heading="'NavigationHeading'"
        :heading="navigationHeading"
      />
    </navigation-blocks>


    <additional-navigation-blocks
      v-if="isEditable"
      :items="additionalNavigatablePages"
    />
  </div>
</template>

<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import pageBlockTypes from '@/vue/mixins/pageBlockTypes'
import PreambleBlock from '@/vue/blocks/PreambleBlock/preambleBlock'
import StorePicker from '@/vue/components/storePicker/storePicker'
import UserGroceryBagInfo from '@/vue/components/userGroceryBagInfo/groceryBagInfo'
import axios from 'axios'
import { mapMutations, mapState } from 'vuex'

  export default {
    name: "GroceryBagOverviewPage",
    components: {
      PreambleBlock,
      StorePicker,
      UserGroceryBagInfo
    },
    mixins: [pageWithNavigation, pageBlockTypes],
    props: {
      title: {
        type: String,
        default:  ""
      },
      preamble: {
        type: String,
        default:  ""
      },
      contentArea: {
        type: Array,
        default: () => []
      },
      accordionShowMoreLimit: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        bags: null,
        discountCode: null,
        showDiscountCodeInput: false,
        selectedDays: null,
        selectedPersons: null,
        glutenFree: false,
        lactoseFree: false,
        vegetarian: false,
      }
    },
    computed: {
      ...mapState([
        'store',
        'selectedDeliveryMethod'
      ]),
      bagBlocks () {
        if (!this.bags || !this.bags.groups) {
          return []
        }

        const result = []

        for (let bag of this.bags.groups) {
          if (this.selectedDays) {
            if (bag.products.filter(p => p.days === this.selectedDays).length === 0) {
              continue
            }
          }

          if (this.selectedPersons) {
            if (bag.products.filter(p => p.peoples === this.selectedPersons).length === 0) {
              continue
            }
          }

          if (this.glutenFree) {
            if (bag.products.filter(p => p.glutenFree === true).length === 0) {
              continue
            }
          }

          if (this.lactoseFree) {
            if (bag.products.filter(p => p.lactoseFree === true).length === 0) {
              continue
            }
          }

          if (this.vegetarian) {
            if (bag.products.filter(p => p.vegetarian === true).length === 0) {
              continue
            }
          }

          bag.component = "GroceryBagBlock"
          bag.inViewKey = bag.name + result.length
          bag.link = './' + bag.name.toLowerCase().replaceAll(' ', '-')
          result.push(bag)
        }

        const fill = (result.length + 1) % 3
        const fills = []

        for (let i = 0; i < fill; i++) {
          fills.push({})
        }

        return [...result,  ...this.contentArea, ...fills]
      },
      canSelectGlutenFree () {
        const groups = this.applyFilter(null, null, ['days','peoples','lactoseFree','vegetarian'])
        if (!groups) { return true }

        return groups.filter(
          b => b.products.filter(
            p => p.glutenFree).length > 0).length > 0
      },
      canSelectLactoseFree () {
        const groups = this.applyFilter(null, null, ['days','peoples','glutenFree','vegetarian'])
        if (!groups) { return true }

        return groups.filter(
          b => b.products.filter(
            p => p.lactoseFree).length > 0).length > 0
      },
      canSelectVegetarian () {
        const groups = this.applyFilter(null, null, ['days','peoples','lactoseFree','glutenFree'])
        if (!groups) { return true }

        return groups.filter(
          b => b.products.filter(
            p => p.vegetarian).length > 0).length > 0
      },
      hasFilter () {
        return this.selectedDays != null
          || this.selectedPersons != null
          || this.lactoseFree
          || this.glutenFree
          || this.vegetarian
      },
      days () {
        const actualDays = []

        if (!this.bags || !this.bags.groups) {
          return new Set()
        }

        for (const bag of this.bags.groups) {
          for(const prod of bag.products) {
            actualDays.push(prod.days)
          }
        }

        return new Set(actualDays.sort())
      },
      peoples () {
        const actualPeoples = []

        if (!this.bags || !this.bags.groups) {
          return new Set()
        }

        for (const bag of this.bags.groups) {
          for(const prod of bag.products) {
            actualPeoples.push(prod.peoples)
          }
        }

        return new Set(actualPeoples.sort())
      }
    },
    watch: {
      store () {
       this.getGroceryBags()
      },
      glutenFree () { this.updateUrl('g', this.glutenFree) },
      lactoseFree () { this.updateUrl('l', this.lactoseFree) },
      vegetarian () { this.updateUrl('v', this.vegetarian) },
      selectedDays () { this.updateUrl('d', this.selectedDays) },
      selectedPersons () { this.updateUrl('p', this.selectedPersons) },
    },
    beforeDestroy () {
      document.removeEventListener('topNavStoreChange', this.handleStoreCookieChanged)
    },
    mounted () {
      document.addEventListener('topNavStoreChange', this.handleStoreCookieChanged)
      this.discountCode = localStorage.getItem('discountCode')

      if (window.location.search) {
        const params = new URLSearchParams(window.location.search)
        if (params.has('d')) {this.selectedDays = parseInt(params.get('d'), 10)}
        if (params.has('p')) {this.selectedPersons = parseInt(params.get('p'), 10)}
        if (params.has('l')) {this.lactoseFree = params.get('l') == 'true'}
        if (params.has('g')) {this.glutenFree = params.get('g') == 'true'}
        if (params.has('v')) {this.vegetarian = params.get('v') == 'true'}
      }

      this.getGroceryBags()
    },
    methods: {
      ...mapMutations([
        'SET_STORE'
      ]),
      handleStoreCookieChanged (event) {
        this.$store.dispatch('handleStoreChangedEvent', event)
      },
      applyDiscountCode () {
        localStorage.setItem('discountCode', this.discountCode)
        this.showDiscountCodeInput = false
        this.getGroceryBags()
      },
      applyFilter (peoples, days, fields) {
        let { groups } = this.bags
        if (!groups) {return}

        if (fields.includes('days') && (this.selectedDays !== null || peoples !== null)) {
          groups = groups.filter(
            b => b.products.filter(
              p => p.days === (this.selectedDays === null ? p.days : this.selectedDays)
                && (peoples === null ? true : p.peoples === peoples)).length > 0)
        }

        if (fields.includes('peoples') && (this.selectedPersons !== null || days !== null)) {
          groups = groups.filter(
            b => b.products.filter(
              p => p.peoples === (this.selectedPersons === null ? p.peoples : this.selectedPersons)
                && (days === null ? true : p.days === days)).length > 0)
        }

        if (fields.includes('glutenFree') && this.glutenFree) {
          groups = groups.filter(
            b => b.products.filter(
              p => p.glutenFree).length > 0)
        }

        if (fields.includes('lactoseFree') && this.lactoseFree) {
          groups = groups.filter(
            b => b.products.filter(
              p => p.lactoseFree).length > 0)
        }

        if (fields.includes('vegetarian') && this.vegetarian) {
          groups = groups.filter(
            b => b.products.filter(
              p => p.vegetarian).length > 0)
        }

        return groups
      },
      canSelectDay (day) {
        let groups = this.applyFilter(null, day, ['peoples','lactoseFree','glutenFree','vegetarian'])
        return groups.length > 0
      },
      canSelectPerson (person) {
        let groups = this.applyFilter(person, null, ['days','lactoseFree','glutenFree','vegetarian'])
        return groups.length > 0
      },
      clearFilter () {
        this.selectedDays = null
        this.selectedPersons = null
        this.glutenFree = null
        this.lactoseFree = null
        this.vegetarian = null
      },
      getGroceryBags () {
        this.groceryBags = [],
        this.renderContent = []

        const query = {}

        if (this.discountCode) {
          query.discountCode = this.discountCode
        }

        if (this.store) {
          query.storeId = this.store.id
          query.deliveryMethod = this.selectedDeliveryMethod
        }

        const encodedQuery = Object.keys(query).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
        }).join('&')

        const searchUrl = `${this.$root.envConfig.baseUrl}/api/grocerybag/products?${encodedQuery}`

        axios.get(searchUrl)
          .then(data => this.setRenderContent(data.data))
          .catch(err => console.log(err))
      },
      setRenderContent (bags) {
        this.bags = bags
      },
      updateUrl (key, value) {
        let search = new URLSearchParams(window.location.search)
        if (value) {
          search.set(key, value)
        } else {
          search.delete(key)
        }
        window.history.replaceState('', '', `?${search.toString()}`)
      }
    }
  }
</script>

<style lang="scss">
  .grocery-bag-oveview-page {
    .preamble {
      margin: 2rem 0;
      padding-bottom: 0;
      color: $color-brown-dark;
      display: flex;
      align-items: flex-end;
    }

    .content-area-wrapper {
      margin-top: 0;
    }

    .order-options {
      color: $color-brown-dark;
      margin-bottom: 1rem;

      .order-options-items {
        display: flex;
        flex-flow: row wrap;

        &--peoples,
        &--days {
          margin-right: 1.5rem;
        }

        &--lactose,
        &--gluten,
        &--vegetarian,
        &--discount {
          align-self: flex-end;
          margin: 0 1rem 0.4rem 0;

          @include media-breakpoint-up(lg) {
            margin-bottom: 0;
          }
        }

        &--discount {
          margin-bottom: 1.3rem;
          display: flex;

          @include media-breakpoint-up(lg) {
            margin-bottom: 0.4rem;
          }

          .code {
            font-weight: 600;
          }
        }
      }

      .order-label {
        font-weight: bold;
        margin-bottom: 0.5rem;
        margin-top: 0;
      }
    }

    .discount-code-container {
      margin-bottom: -0.2rem;

      .discount-code-input {
        border: 1px solid #bdbbb9;
        background: #fff;
        padding: 0.25rem;
        border-radius: 0.25rem;
        color: #3a3a3a;
      }
    }

    .filter-header {
      display: flex;
      align-items: baseline;

      &_title {
        @include font(rubrik, 2, "bold");

        color: $color-brown-dark;
        margin-bottom: 0.5rem;
        margin-top: 0;
      }
    }

    .radio-wrapper {
      display: flex;
      position: relative;
      margin: 0 0 1rem;

      @include media-breakpoint-up(lg) {
        margin-bottom: 0;
      }

      input[type="radio"] {
        opacity: 0;
        position: absolute;
        margin: 0;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
      }

      label {
        padding: 0.25rem 1rem;
        border-top: 1px solid $color-grey-light;
        border-left: 1px solid $color-grey-light;
        border-bottom: 1px solid $color-grey-light;
        background-color: $color-white;

        @include font(text, 3 "black");

        &:first-of-type {
          border-radius: 0.25rem 0 0 0.25rem;
        }

        &:last-of-type {
          border-right: 1px solid $color-grey-light;
          border-radius: 0 0.25rem 0.25rem 0;
          margin-left: -1px;
        }

        &:only-of-type {
          border-radius: 0.25rem;
        }
      }

      [type="radio"]:checked + label {
        background: $color-red;
        color: $color-white;
        font-weight: 600;
      }

      [type="radio"]:disabled + label {
        background: $color-white;
        color: $color-grey-mid;
        cursor: not-allowed;
      }
    }

    .checkbox {
      margin-left: -0.375rem;
      margin-bottom: 0.5rem;

      @include media-breakpoint-up(lg) {
        margin-bottom: 0;
      }

      &__label::before {
        background: $color-white;
      }

      &__label {
        margin-left: 0.25rem;

        @include font(text, 3, "normal");
      }
    }

    .legal small {
      color: $color-brown-dark;

      @include font(text, 3, "normal");
    }
  }
</style>
